export default "__VITE_ASSET__DRrWr9S5__"